const policyData = {
  privacy: {
    title: "Privacy Policy",
    intro: [
      "This notice explains how isanroute collects, uses, shares and protects personal information when you browse this website, place an order or contact us. isanroute is the controller of the information described here.",
      "This notice should be read with our Cookie Policy. It does not cover third-party websites that have their own privacy notices.",
    ],
    sections: [
      {
        heading: "Information we collect",
        bullets: [
          "Identity and contact information, including your name, email address, delivery and billing addresses and, where provided, company name.",
          "Order and transaction information, including products, sizes, quantities, price, delivery status, returns and customer-service history.",
          "Payment metadata supplied by our payment provider, such as payment status, method type and a transaction reference. We do not ask you to enter full card details into the isanroute checkout form.",
          "Technical and usage information, such as IP address, browser and device type, requested pages, security logs and essential browser-storage data.",
          "Communications and preferences, including messages you send us and any marketing choice you make.",
          "Information needed to prevent fraud, comply with sanctions and handle legal claims.",
        ],
      },
      {
        heading: "How we collect information",
        paragraphs: [
          "We collect information directly from you, automatically when your browser interacts with the site, and from service providers involved in payment, delivery, security and order fulfilment. If you provide another person's delivery details, you must have permission to do so.",
        ],
      },
      {
        heading: "Why we use it and our legal bases",
        bullets: [
          "Contract: to take payment, fulfil and deliver orders, process returns and provide requested support.",
          "Legitimate interests: to secure the site, prevent fraud, improve operations, answer non-order enquiries and establish or defend legal claims, where those interests are not overridden by your rights.",
          "Legal obligation: to keep tax and accounting records, respond to lawful requests, meet consumer-protection duties and support product-safety actions.",
          "Consent: for non-essential cookies or direct marketing where consent is required. You can withdraw consent at any time without affecting earlier lawful processing.",
        ],
      },
      {
        heading: "Who receives information",
        paragraphs: [
          "We disclose only what is reasonably necessary to payment processors, banks, delivery carriers, hosting and IT suppliers, fraud-prevention providers, professional advisers and public authorities where legally required. Providers may use information only under their own legal duties or our documented instructions, as applicable.",
          "We do not sell personal information. We do not share it for cross-context behavioural advertising. If the business is reorganised, relevant information may transfer subject to confidentiality and applicable law.",
        ],
      },
      {
        heading: "International transfers",
        paragraphs: [
          "A provider may process information outside Ireland or the European Economic Area. Where required, we use an adequacy decision, approved contractual protections or another lawful transfer mechanism and assess supplementary safeguards.",
        ],
      },
      {
        heading: "How long we keep information",
        paragraphs: [
          "We keep order and accounting records for the period required by tax, accounting and consumer law. Enquiries are normally kept only while needed to resolve the issue and manage any related claim. Security logs are kept for a limited period appropriate to the risk. Browser cart data remains on your device until it is cleared or replaced.",
          "We may retain a minimal record longer where necessary to honour an opt-out, resolve a dispute or meet a legal obligation. When information is no longer needed, it is deleted or anonymised.",
        ],
      },
      {
        heading: "Your rights",
        bullets: [
          "Ask for access to and a copy of your personal information.",
          "Ask us to correct inaccurate or incomplete information.",
          "Ask for deletion or restriction where the legal conditions apply.",
          "Object to processing based on legitimate interests and object at any time to direct marketing.",
          "Receive certain information in a portable format where the right applies.",
          "Withdraw consent and complain to the Irish Data Protection Commission or your local supervisory authority.",
        ],
        paragraphs: [
          "To exercise a right, email send@isanroute.space. We may request proportionate information to verify identity. Rights are not absolute, and we will explain any lawful limitation.",
        ],
      },
      {
        heading: "Automated decisions and children",
        paragraphs: [
          "We may use automated signals to flag suspicious payments, but we do not intend to make solely automated decisions that produce legal or similarly significant effects without appropriate safeguards. The store is not directed to children under 16, and children should not submit personal information or place orders without a parent or guardian.",
        ],
      },
      {
        heading: "Security, changes and contact",
        paragraphs: [
          "We use reasonable organisational and technical measures, but no online system is completely secure. Do not email card numbers or account passwords. We may update this notice as our services or legal duties change and will show the revised date here.",
          "Privacy requests may be sent to send@isanroute.space or by post to isanroute, 9 Essex Street East, Dublin D02 RW53, Ireland.",
        ],
      },
    ],
  },

  cookies: {
    title: "Cookie & Browser Storage Policy",
    intro: [
      "This policy explains how isanroute uses cookies, local storage and similar technologies. A cookie is a small file stored by a browser; local storage is browser space that can retain information between visits.",
    ],
    sections: [
      {
        heading: "What this site currently stores",
        paragraphs: [
          "The shopping cart uses a local-storage item named cartItems so that selected products, quantities, sizes and colours remain available when you move between pages or return later. It is strictly necessary for the cart experience requested by you and does not contain card details.",
          "The site may also use short-lived technical data needed to deliver pages, protect forms and complete a secure hosted payment. At the date shown above, isanroute does not intentionally set advertising or behavioural-profiling cookies on this website.",
        ],
      },
      {
        heading: "Third-party services",
        paragraphs: [
          "Fonts, security infrastructure, a hosted payment page or other external services may receive technical request data and may use technologies governed by their own notices. A payment provider may set essential cookies after you continue to its domain.",
        ],
      },
      {
        heading: "Consent for optional technologies",
        paragraphs: [
          "If we introduce analytics, personalisation or advertising technologies that require consent, they will remain off until you make an affirmative choice. Refusing optional technologies will not prevent access to the store. You will be able to change that choice as easily as you gave it.",
        ],
      },
      {
        heading: "How to manage storage",
        paragraphs: [
          "You can remove or block cookies and local storage using browser settings. Clearing cartItems will empty the saved cart on that browser. Blocking strictly necessary storage may prevent cart or checkout features from working as expected.",
        ],
      },
      {
        heading: "Duration and updates",
        paragraphs: [
          "Cart data remains until it is cleared, overwritten or removed by the browser. Temporary security and session data expires according to the provider's settings. We will update this page before materially changing the categories or purposes described here.",
        ],
      },
    ],
  },

  terms: {
    title: "Terms of Service",
    intro: [
      "These terms apply when you use this website or buy products from isanroute. By placing an order, you confirm that you are legally capable of entering a contract and that the information you provide is accurate.",
      "Nothing in these terms limits mandatory rights that cannot lawfully be excluded, including applicable consumer rights.",
    ],
    sections: [
      {
        heading: "About us and contact",
        paragraphs: [
          "isanroute operates this online store from 9 Essex Street East, Dublin D02 RW53, Ireland. Contact send@isanroute.space for customer-service or legal enquiries.",
        ],
      },
      {
        heading: "Products and eligibility",
        paragraphs: [
          "Products are offered for personal, lawful use and are subject to availability. Images and colours can vary with screens and normal production differences. Material, measurement and care information on the product page forms part of the description.",
          "You must not order for unlawful export, sanctioned destinations, unauthorised resale or suspected fraud. We may apply reasonable quantity limits.",
        ],
      },
      {
        heading: "How the contract is formed",
        paragraphs: [
          "The checkout gives you an opportunity to review your cart, delivery information and total before paying. An order acknowledgement confirms receipt, not acceptance. A contract is formed when we send a dispatch confirmation, unless mandatory law provides otherwise.",
          "We may reject or cancel an order before dispatch for unavailability, an obvious price or description error, failed authorisation, delivery restrictions, suspected fraud or legal compliance. If payment was captured, we will return it to the original method.",
        ],
      },
      {
        heading: "Price, payment and delivery",
        paragraphs: [
          "Prices are displayed in USD. Shipping and any applicable charges are shown before the order is submitted. Payment is processed through a hosted provider. Delivery estimates are not guarantees, but mandatory delivery deadlines and remedies continue to apply.",
        ],
      },
      {
        heading: "Returns, withdrawal and faulty goods",
        paragraphs: [
          "Our Returns & Refunds Policy explains the voluntary 28-day return window and the separate statutory right to withdraw from most online purchases. Faulty, unsafe, misdescribed or non-conforming products are handled under applicable consumer law and our Faulty Goods Policy.",
        ],
      },
      {
        heading: "Website availability and misuse",
        paragraphs: [
          "We may maintain, secure or update the site and do not promise uninterrupted availability. You must not interfere with the site, introduce malicious code, scrape it at a disruptive scale, attempt unauthorised access or use its content in a way that infringes another person's rights.",
        ],
      },
      {
        heading: "Liability",
        paragraphs: [
          "We do not exclude liability where exclusion is unlawful, including liability for death or personal injury caused by negligence, fraud, or breach of mandatory consumer obligations. Subject to that, we are not responsible for losses that were not reasonably foreseeable when the contract was made or for business losses arising from a consumer purchase.",
          "You are responsible for following product care, safety and use instructions. This clause does not shift responsibility for a defective or unsafe product to you.",
        ],
      },
      {
        heading: "Governing law and changes",
        paragraphs: [
          "These terms are governed by Irish law. Consumers may also rely on mandatory protections and courts available in their country of residence. We may update these terms prospectively; the terms shown when an order is placed normally govern that purchase.",
        ],
      },
    ],
  },

  shipping: {
    title: "Shipping & Delivery Policy",
    intro: [
      "This policy describes order preparation, shipping charges, delivery and what to do if a parcel is delayed, lost or damaged.",
    ],
    sections: [
      {
        heading: "Processing time",
        paragraphs: [
          "In-stock orders are normally prepared within 1–2 business days after payment is authorised. Weekends, public holidays, fraud review, address checks and exceptionally busy periods may add time. A dispatch email is sent when tracking is available.",
        ],
      },
      {
        heading: "Shipping charge and destination",
        paragraphs: [
          "A flat shipping charge of $9.99 USD is added to each order and shown before payment. The country selector at checkout shows destinations currently served. We cannot ship where carrier rules, export controls or sanctions prohibit delivery.",
        ],
      },
      {
        heading: "Delivery estimates",
        paragraphs: [
          "Any delivery window shown in checkout or a dispatch message is an estimate unless expressly stated as a guaranteed date. If no delivery time is agreed, eligible EU consumer orders will be delivered without undue delay and no later than the applicable statutory deadline, normally 30 days after the contract is made.",
        ],
      },
      {
        heading: "Tracking, safe place and signature",
        paragraphs: [
          "Use tracking and carrier options carefully. If you authorise a safe place, neighbour or other alternative delivery, risk may pass when the parcel is delivered according to that instruction. High-value orders may require a signature and cannot always be redirected.",
        ],
      },
      {
        heading: "Address changes and failed delivery",
        paragraphs: [
          "Check the address before submitting the order. Contact us immediately if it is wrong; changes are not guaranteed after fulfilment begins. If a parcel is returned because the address was incomplete, delivery was refused or collection was missed, we may deduct reasonable unrecoverable return or reshipping costs where law permits.",
        ],
      },
      {
        heading: "Customs, duties and import taxes",
        paragraphs: [
          "International shipments may be assessed import VAT, customs duty or handling fees by the destination country unless checkout expressly states that duties are included. The recipient is responsible for disclosed or lawfully imposed import charges. We do not undervalue parcels or mark purchases as gifts.",
        ],
      },
      {
        heading: "Delay, loss or damage",
        paragraphs: [
          "If tracking stops or a parcel arrives visibly damaged, email send@isanroute.space promptly with the order number and photos where relevant. Unless you independently chose a carrier we did not offer, we remain responsible for the goods until they are delivered to you or your nominated recipient. We will investigate and provide the remedy required by law.",
        ],
      },
    ],
  },

  returns: {
    title: "Returns & Refunds Policy",
    intro: [
      "This policy combines isanroute's voluntary 28-day return offer with statutory rights that may apply to online consumers. Statutory rights take priority where they are more favourable.",
    ],
    sections: [
      {
        heading: "Voluntary 28-day returns",
        paragraphs: [
          "You may ask to return an eligible item within 28 days after receipt. It must be unworn, unwashed, unaltered and, except for reasonable inspection, unused, with original tags, accessories and packaging. Returns that fall outside statutory rights may be refused if these conditions are not met.",
        ],
      },
      {
        heading: "Statutory right to withdraw",
        paragraphs: [
          "Eligible EU and EEA consumers generally have 14 days after delivery to tell us they are withdrawing from an online purchase without giving a reason, followed by 14 days to send the goods back. A clear email to send@isanroute.space is sufficient. See the Right of Withdrawal page for the process and model wording.",
          "The statutory right can have exceptions, including genuinely personalised goods, sealed hygiene goods after unsealing, perishable goods and other categories defined by law. An exception will be applied only where it lawfully fits the product and was disclosed before purchase.",
        ],
      },
      {
        heading: "How to return",
        numbered: [
          "Email send@isanroute.space with the order number, item and reason so we can provide instructions.",
          "Pack the item securely. Put footwear boxes or other retail packaging inside protective outer packaging.",
          "Send the parcel using a tracked service to: isanroute, 9 Essex Street East, Dublin D02 RW53, Ireland.",
          "Keep proof of postage until the return and refund are confirmed.",
        ],
      },
      {
        heading: "Return shipping",
        paragraphs: [
          "For a change-of-mind return, you pay the direct return cost unless we offered free return shipping. We cover reasonable return costs for goods confirmed as faulty, damaged, incorrect or materially misdescribed. For international returns, mark customs documents accurately as RETURNED GOODS; do not make a false declaration.",
        ],
      },
      {
        heading: "Inspection and diminished value",
        paragraphs: [
          "You may inspect an item as you reasonably would in a shop. For statutory withdrawals, we may make a lawful deduction for loss in value caused by handling beyond what is necessary to establish the item's nature, characteristics and functioning. This does not apply to a defect for which we are responsible.",
        ],
      },
      {
        heading: "Refund timing and method",
        paragraphs: [
          "Approved refunds are made to the original payment method. For a statutory withdrawal, we refund the purchase price and the cost of our least expensive standard delivery option, and may wait until the goods arrive or you provide evidence of sending them. We process other approved returns within 5–10 business days after inspection; banks may take additional time to post the credit.",
        ],
      },
      {
        heading: "Exchanges, gifts and sale items",
        paragraphs: [
          "Exchanges depend on stock and may be handled as a return and new order. Refunds for gifts go to the original payment method unless law requires otherwise. Sale items have the same rights for faults and statutory withdrawal; a reduced price alone does not remove those rights.",
        ],
      },
      {
        heading: "Faulty or incorrect goods",
        paragraphs: [
          "Do not use an item that may be unsafe. Contact us with photos and a description. The voluntary return conditions do not limit remedies for faulty, damaged, unsafe, misdescribed or non-conforming goods.",
        ],
      },
    ],
  },

  withdrawal: {
    title: "Right of Withdrawal",
    intro: [
      "This page explains how eligible consumers can cancel most online purchases during the statutory cooling-off period. It is separate from the isanroute voluntary 28-day returns offer.",
    ],
    sections: [
      {
        heading: "Time limit",
        paragraphs: [
          "You normally have 14 days from the day after you, or a person nominated by you, receives the goods to notify us. For a single order delivered in parts, the period normally begins after the final part is received. You then normally have 14 days to return the goods.",
        ],
      },
      {
        heading: "How to withdraw",
        paragraphs: [
          "Before the deadline, email send@isanroute.space with an unambiguous statement that you wish to withdraw. Include your name, order number, the goods, order date, delivery date and the address used for the order. You may use the wording below, but it is not mandatory.",
        ],
        notice: "Model wording: I hereby give notice that I withdraw from my contract for the sale of [item], ordered on [date] and received on [date]. Name: [name]. Address: [address]. Order number: [number]. Date: [date].",
      },
      {
        heading: "Returning the goods",
        paragraphs: [
          "Send goods to isanroute, 9 Essex Street East, Dublin D02 RW53, Ireland, within 14 days after notifying us. You normally bear the direct cost of return. Use suitable protective packaging and retain proof of postage.",
        ],
      },
      {
        heading: "Refund",
        paragraphs: [
          "We refund eligible payments, including the cost of our least expensive standard delivery option, to the original payment method. We may withhold the refund until the goods are received or you supply evidence of return. Any lawful deduction for handling beyond a shop-style inspection will be explained.",
        ],
      },
      {
        heading: "Exceptions",
        paragraphs: [
          "The right may not apply to made-to-order or clearly personalised goods, rapidly perishable goods, sealed hygiene goods once unsealed, sealed audio or software once unsealed, or digital content begun with the required express consent and acknowledgement. We will not rely on an exception that was not applicable and properly disclosed.",
        ],
      },
    ],
  },

  payments: {
    title: "Payment & Billing Policy",
    intro: [
      "This policy explains how payment is authorised, what information is handled and how payment problems are resolved.",
    ],
    sections: [
      {
        heading: "Accepted payment methods",
        paragraphs: [
          "Available methods are displayed at checkout and may vary by device, country or payment provider. A displayed logo does not guarantee that every card or wallet is available for every order.",
        ],
      },
      {
        heading: "Currency and total",
        paragraphs: [
          "Orders are charged in USD. The checkout total includes the product subtotal and $9.99 USD shipping fee, plus any other charge clearly shown before you pay. Your bank may apply exchange-rate differences or a foreign transaction fee; those charges are controlled by the bank, not isanroute.",
        ],
      },
      {
        heading: "Hosted payment and card data",
        paragraphs: [
          "After you submit delivery information, payment is completed on a secure hosted payment page. isanroute does not request or store the full card number or card security code in its checkout form. The payment provider may return a transaction reference, method type and status so we can manage the order.",
        ],
      },
      {
        heading: "Authorisation and capture",
        paragraphs: [
          "Submitting payment authorises the provider and card issuer to check and process the amount shown. A pending authorisation is not always a completed charge. If an order is rejected or cancelled, an authorisation release can take several business days according to the issuer.",
        ],
      },
      {
        heading: "Failed, duplicate or suspicious payments",
        paragraphs: [
          "A payment may fail because of issuer controls, incorrect details, security checks or technical interruption. Do not repeatedly submit a payment if the status is unclear; first check your email and banking app, then contact us. We investigate reported duplicate charges and may ask for non-sensitive evidence. Never send a full card number or security code.",
        ],
      },
      {
        heading: "Refunds and chargebacks",
        paragraphs: [
          "Refunds go to the original method unless law requires another solution. If you do not recognise a transaction, contact us and your payment provider promptly. Starting a chargeback does not remove your obligation to return goods where appropriate, and we may provide order and delivery evidence to the provider.",
        ],
      },
    ],
  },

  orders: {
    title: "Order, Change & Cancellation Policy",
    intro: [
      "This policy covers checkout review, order acceptance, customer-requested changes and cancellations before or after dispatch.",
    ],
    sections: [
      {
        heading: "Review before ordering",
        paragraphs: [
          "Check the product, size, colour, quantity, address, email and total before selecting Pay Now. You are responsible for accurate information, but this does not remove rights relating to a defective or misdescribed product.",
        ],
      },
      {
        heading: "Acknowledgement and acceptance",
        paragraphs: [
          "An automated acknowledgement means we received the request. It does not guarantee acceptance or stock. Acceptance normally occurs when we confirm dispatch.",
        ],
      },
      {
        heading: "Changes and cancellation before dispatch",
        paragraphs: [
          "Email send@isanroute.space immediately. We will try to change an address, size or item, or cancel the order, but cannot guarantee this once picking, packing or carrier handover has begun. We will never ask you to send card details to make a change.",
        ],
      },
      {
        heading: "Cancellation after dispatch",
        paragraphs: [
          "Once dispatched, carrier redirection may be unavailable. Eligible consumers may use the statutory withdrawal process after delivery, and our voluntary return policy may also apply. Do not refuse an international parcel without contacting us because avoidable carrier or customs costs may arise.",
        ],
      },
      {
        heading: "When we may cancel",
        bullets: [
          "The product is unavailable or fails a quality check.",
          "There is an obvious and genuine price or description error.",
          "Payment is not authorised or credible fraud indicators remain unresolved.",
          "The address is incomplete, undeliverable or in a restricted destination.",
          "The order would breach law, sanctions, export controls or reasonable quantity limits.",
        ],
        paragraphs: [
          "We will explain the cancellation where legally permitted and return captured payment to the original method.",
        ],
      },
      {
        heading: "Split orders and out-of-stock items",
        paragraphs: [
          "We may ask before splitting a shipment or substituting an item. We do not substitute without agreement. If part of an order cannot be supplied, the unavailable part is refunded and your rights for the remainder are unaffected.",
        ],
      },
    ],
  },

  pricing: {
    title: "Pricing, Taxes & Duties Policy",
    intro: [
      "This policy explains displayed prices, corrections, tax treatment and possible import charges.",
    ],
    sections: [
      {
        heading: "Displayed currency and charges",
        paragraphs: [
          "Product prices and order totals are displayed in USD. The $9.99 USD shipping charge is shown separately. Any tax collected by us will be identified before payment where the checkout supports it.",
        ],
      },
      {
        heading: "Pricing accuracy",
        paragraphs: [
          "We take reasonable care with prices. If a price is obviously wrong, we may contact you to confirm the correct price or cancel before dispatch. We will not increase an accepted order price after dispatch. Any captured amount for a cancelled item will be refunded.",
        ],
      },
      {
        heading: "Price changes and prior purchases",
        paragraphs: [
          "Prices may change prospectively because of promotions, supplier changes, exchange rates or corrections. A later reduction does not automatically create a refund for an earlier purchase, except where required by law or an express price-adjustment offer.",
        ],
      },
      {
        heading: "Import VAT, duty and fees",
        paragraphs: [
          "Unless checkout clearly states duties paid or taxes included for your destination, the recipient may have to pay import VAT, customs duty and carrier handling charges. These are assessed by local authorities or carriers. Contact the relevant customs authority before ordering if you need an estimate.",
        ],
      },
      {
        heading: "Currency conversion",
        paragraphs: [
          "A bank or wallet may display an estimated local-currency amount and apply its own rate or fee. isanroute controls only the USD amount submitted. Refund exchange values can differ from the original debit because of issuer rates.",
        ],
      },
      {
        heading: "Promotional price history",
        paragraphs: [
          "Where law requires a prior-price reference for a reduction, we will use the legally required comparison period and will not create false reference prices or artificial urgency.",
        ],
      },
    ],
  },

  promotions: {
    title: "Promotions & Discount Codes Policy",
    intro: [
      "These rules apply to discount codes, sale events, gifts with purchase and other promotional offers unless a specific promotion states different lawful terms.",
    ],
    sections: [
      {
        heading: "Using a code",
        paragraphs: [
          "Enter a valid code before submitting payment. Codes cannot normally be added retrospectively. A promotion may have dates, eligible products, territory, minimum spend, usage or customer limits disclosed with the offer.",
        ],
      },
      {
        heading: "Combining offers",
        paragraphs: [
          "Only one code may be used per order unless the offer says otherwise. Gift cards are a payment method rather than a discount, but technical or promotion-specific limits may apply. Shipping, taxes and gift-card purchases may be excluded from percentage discounts where disclosed.",
        ],
      },
      {
        heading: "Fair use",
        paragraphs: [
          "Codes must not be guessed, altered, sold, published contrary to their issue terms or used through automated or fraudulent activity. We may cancel misuse and refund the amount actually paid, without affecting orders made legitimately.",
        ],
      },
      {
        heading: "Returns from a promotion",
        paragraphs: [
          "A refund reflects the amount paid for the returned item after the discount was allocated. If keeping part of a bundle means the order no longer meets a clearly disclosed promotion condition, any lawful adjustment will be explained. Statutory rights are unchanged.",
        ],
      },
      {
        heading: "Errors, availability and changes",
        paragraphs: [
          "Promotions are subject to stock. We may correct a genuine error or end an offer prospectively where permitted, but will not use this clause to avoid an already formed contract or mandatory consumer rights.",
        ],
      },
    ],
  },

  giftCards: {
    title: "Gift Card Policy",
    intro: [
      "This policy applies if isanroute offers gift cards or vouchers. The sale page and card email will state the value, delivery method and any additional terms before purchase.",
    ],
    sections: [
      {
        heading: "Validity",
        paragraphs: [
          "A gift card subject to Irish gift-voucher law will not expire earlier than five years after purchase. If a longer period or no expiry is stated on the card, that more favourable term applies. The expiry date will be provided in a durable form where required.",
        ],
      },
      {
        heading: "Redemption and balances",
        paragraphs: [
          "Eligible cards may be used across more than one purchase until the balance is spent, and lawful combinations of multiple cards will not be prohibited. If the order exceeds the balance, the remainder must be paid using an available method.",
        ],
      },
      {
        heading: "Delivery and responsibility",
        paragraphs: [
          "Check the recipient email before purchase. Treat a code like cash and do not post it publicly. Contact us promptly about a card sent to the wrong address, but replacement may not be possible after redemption by a person who obtained the code lawfully.",
        ],
      },
      {
        heading: "Refunds and cash",
        paragraphs: [
          "Gift cards are not redeemable for cash except where law requires. An eligible refund for goods bought with a gift card is normally returned to a gift-card balance; any portion paid by another method is returned to that method. Statutory cancellation rights for an unused digital gift card depend on whether supply began with the required consent.",
        ],
      },
      {
        heading: "Restrictions and misuse",
        paragraphs: [
          "A gift card cannot be used to buy another gift card unless expressly allowed. We may pause a card linked to fraud, theft or payment reversal while we investigate. This does not affect the rights of a legitimate cardholder.",
        ],
      },
    ],
  },

  preorders: {
    title: "Pre-order & Back-order Policy",
    intro: [
      "This policy applies only when a product page clearly identifies an item as a pre-order or back-order before payment.",
    ],
    sections: [
      {
        heading: "Estimated availability",
        paragraphs: [
          "The product page will provide the best available dispatch estimate. Production, inbound freight or quality checks may change it. An estimate is not a guaranteed date unless expressly stated as one.",
        ],
      },
      {
        heading: "Payment",
        paragraphs: [
          "Checkout will state whether payment is taken at order or nearer dispatch. Your payment provider may require a new authorisation if an earlier authorisation expires. We will not add an undisclosed charge because dispatch was delayed.",
        ],
      },
      {
        heading: "Mixed baskets",
        paragraphs: [
          "In-stock and pre-order items may ship together when the last item becomes available unless we agree to split them. We will disclose any additional shipping cost before arranging a split.",
        ],
      },
      {
        heading: "Delay, change or cancellation",
        paragraphs: [
          "If the estimate changes materially, we will provide an update and, where required, a new date or the option to cancel the affected item for a full refund. If a supplier cancels or an item fails quality control, we may cancel and refund it rather than supply a substitute without permission.",
        ],
      },
      {
        heading: "Customer cancellation and returns",
        paragraphs: [
          "Email us to cancel before dispatch. Any mandatory cancellation or withdrawal right remains available. A pre-order is not automatically personalised; the personalised-goods exception applies only where the item was genuinely made to your individual specification and the exception was disclosed.",
        ],
      },
    ],
  },

  productInfo: {
    title: "Product Information & Availability Policy",
    intro: [
      "This policy explains how descriptions, images, sizing, materials and stock information should be read.",
    ],
    sections: [
      {
        heading: "Descriptions and images",
        paragraphs: [
          "We aim to describe the main characteristics accurately. Screen settings, lighting and normal material variation can make colour and texture appear different. Images may show styling items that are not included; the product title and description identify what is sold.",
        ],
      },
      {
        heading: "Sizing and measurements",
        paragraphs: [
          "Sizing can vary by product and maker. Use the product-specific options and measurements where provided rather than assuming a standard fit. Measurements may have a small tolerance. Contact us before ordering if a missing measurement is important to your decision.",
        ],
      },
      {
        heading: "Materials, care and natural variation",
        paragraphs: [
          "Follow the sewn-in label and product care instructions. Natural leather, wood, ceramic, hand-finished textiles and similar materials may show grain, tone or shape variation that is not a defect. Variation does not excuse a material difference from the description or a lack of conformity.",
        ],
      },
      {
        heading: "Availability",
        paragraphs: [
          "A product shown online can sell out before inventory synchronises. Adding an item to the cart does not reserve it. If an ordered item is unavailable, we will not make an unapproved substitution and will refund any captured payment for that item.",
        ],
      },
      {
        heading: "Authenticity and third-party brands",
        paragraphs: [
          "We do not knowingly offer counterfeit or unauthorised goods. Third-party names and marks identify their respective products and remain the property of their owners; their appearance does not transfer ownership to isanroute or imply an endorsement beyond an authentic retail relationship where one exists.",
        ],
      },
      {
        heading: "Corrections",
        paragraphs: [
          "We may correct a typographical or technical error. If a material correction affects an unfulfilled order, we will contact you so you can confirm or cancel. Mandatory rights for misleading or misdescribed goods remain available.",
        ],
      },
    ],
  },

  warranty: {
    title: "Faulty Goods & Legal Guarantee Policy",
    intro: [
      "This policy applies when goods are faulty, damaged on arrival, unsafe, not as described or otherwise fail to conform to the contract. It is not limited by the voluntary 28-day return conditions.",
    ],
    sections: [
      {
        heading: "Your legal rights",
        paragraphs: [
          "Consumers in the EU have a minimum two-year legal guarantee for new goods, and national law may provide longer or additional remedies. These rights are against the seller and cannot be replaced by a shorter manufacturer warranty or store return window.",
        ],
      },
      {
        heading: "What to do",
        paragraphs: [
          "Stop using an item if continued use could be unsafe. Email send@isanroute.space with the order number, a clear description of the issue and, where practical, photographs. We may ask reasonable diagnostic questions but will not require steps that create danger or significant inconvenience.",
        ],
      },
      {
        heading: "Assessment",
        paragraphs: [
          "We may inspect the product or arrange return. Normal wear, accidental damage, misuse, failure to follow care instructions or an alteration by someone else is not normally a conformity defect, unless the underlying issue or inadequate instructions are our responsibility.",
        ],
      },
      {
        heading: "Remedies",
        paragraphs: [
          "Depending on the law and circumstances, the remedy may be repair, replacement, price reduction or refund. Repair or replacement will be free where required and completed within a reasonable time without significant inconvenience. Where those remedies are impossible, disproportionate, refused or unsuccessful, a price reduction or termination and refund may apply.",
        ],
      },
      {
        heading: "Costs and manufacturer warranties",
        paragraphs: [
          "We cover reasonable necessary return costs for a confirmed non-conforming product. A separate manufacturer guarantee may offer extra benefits under its own clear terms, but it does not reduce the legal guarantee owed by the seller.",
        ],
      },
      {
        heading: "Proof of purchase",
        paragraphs: [
          "An order number helps us locate the transaction, but another reliable proof of purchase may be accepted where law requires. The allocation of proof for when a defect existed follows applicable consumer law.",
        ],
      },
    ],
  },

  consumerRights: {
    title: "Consumer Rights Summary",
    intro: [
      "This plain-language summary highlights important rights that commonly apply to consumers buying online from an Ireland-based trader. It is not a waiver, replacement or exhaustive statement of applicable law.",
    ],
    sections: [
      {
        heading: "Information before purchase",
        paragraphs: [
          "You should receive clear information about the main product characteristics, total price, shipping or other charges, payment, delivery, our identity and contact details, complaint handling and cancellation rights before becoming bound.",
        ],
      },
      {
        heading: "Cooling-off period",
        paragraphs: [
          "For most online goods, eligible EU and EEA consumers can withdraw within 14 days after delivery without giving a reason, subject to lawful exceptions. You normally then have 14 days to return the goods. See our Right of Withdrawal page.",
        ],
      },
      {
        heading: "Conforming goods and legal guarantee",
        paragraphs: [
          "Goods must match their description, be fit for normal and disclosed purposes, have the quality and durability reasonably expected, and include promised accessories or instructions. EU rules provide a minimum two-year legal guarantee for new goods, with national law potentially providing more.",
        ],
      },
      {
        heading: "Delivery",
        paragraphs: [
          "Goods should arrive at the agreed time or, if no time is agreed, within the statutory period that normally applies. Unless you separately appoint a carrier not offered by us, the seller remains responsible until delivery to you or your nominee.",
        ],
      },
      {
        heading: "Unfair terms and practices",
        paragraphs: [
          "Contract terms must be transparent and cannot create an unlawful imbalance. Advertising must not be misleading or omit material information. isanroute will not use false scarcity, fabricated reviews, hidden charges or pre-selected optional payments.",
        ],
      },
      {
        heading: "Complaints",
        paragraphs: [
          "Contact send@isanroute.space first so we can investigate. You may also seek independent advice from the Competition and Consumer Protection Commission, European Consumer Centre for qualifying cross-border disputes, or another competent body. This summary does not restrict court access.",
        ],
      },
    ],
  },

  acceptableUse: {
    title: "Website Acceptable Use Policy",
    intro: [
      "This policy protects shoppers, isanroute and the reliable operation of the website. It applies to browsing, forms, checkout and any other interaction with the site.",
    ],
    sections: [
      {
        heading: "Permitted use",
        paragraphs: [
          "You may browse, shop, contact us and save or print reasonable extracts for personal, non-commercial use. Accessibility tools, search engines following published rules and proportionate security research conducted lawfully are not prohibited by this policy.",
        ],
      },
      {
        heading: "Prohibited conduct",
        bullets: [
          "Attempting unauthorised access, bypassing security, probing accounts or intercepting another person's data.",
          "Introducing malware, abusive traffic, denial-of-service activity or automated requests that materially disrupt the site.",
          "Using false identities, stolen payment credentials, fraudulent chargebacks or orders designed to evade legal restrictions.",
          "Copying, republishing or commercially exploiting site content without a lawful basis or permission.",
          "Submitting unlawful, threatening, defamatory, discriminatory, deceptive or infringing material.",
          "Using the site to facilitate counterfeit trade, unlawful resale, sanctions evasion or any criminal activity.",
        ],
      },
      {
        heading: "Security testing",
        paragraphs: [
          "Do not access customer data, alter records, degrade service or publicly disclose an unremediated vulnerability. Report a suspected vulnerability privately to send@isanroute.space with reproducible detail and allow reasonable time to investigate.",
        ],
      },
      {
        heading: "Enforcement",
        paragraphs: [
          "We may limit access, cancel fraudulent transactions, preserve evidence or report unlawful conduct. Measures will be proportionate and will not be used to avoid legitimate complaints, consumer rights, accessibility technology or lawful criticism.",
        ],
      },
    ],
  },

  intellectualProperty: {
    title: "Intellectual Property Policy",
    intro: [
      "This policy explains ownership and permitted use of content associated with the isanroute website. It does not claim rights that belong to product makers, photographers, licensors or other third parties.",
    ],
    sections: [
      {
        heading: "isanroute content",
        paragraphs: [
          "The isanroute name, original site copy, layout, graphics and other original material created for the store may be protected by copyright, trade mark, design or related law. Protection applies only to the extent owned by or validly licensed to isanroute.",
        ],
      },
      {
        heading: "Third-party rights",
        paragraphs: [
          "Product and company names, logos, designs and other materials belonging to third parties remain theirs. They are used only where there is a lawful retail, descriptive, nominative or licensed basis. No ownership or broader endorsement is implied.",
        ],
      },
      {
        heading: "Personal use",
        paragraphs: [
          "You may view and print reasonable portions for shopping, order records and other personal non-commercial purposes. You may not remove rights notices, reproduce a substantial part of the catalogue, train or populate a competing commercial service from site content, or create misleading copies without permission or another lawful basis.",
        ],
      },
      {
        heading: "User submissions",
        paragraphs: [
          "If you send a review, photo or other material for publication, you must own it or have permission and it must not violate privacy, publicity or intellectual-property rights. We will seek a clear licence before public reuse beyond handling your request; sending a customer-service image alone does not grant unrestricted marketing rights.",
        ],
      },
      {
        heading: "No counterfeit or infringement",
        paragraphs: [
          "isanroute does not knowingly list counterfeit products or publish infringing content. Credible reports are handled under the Notice & Takedown Policy. We may remove material, pause a listing and contact the relevant supplier or rights holder while investigating.",
        ],
      },
    ],
  },

  takedown: {
    title: "Intellectual Property Notice & Takedown Policy",
    intro: [
      "Rights holders and authorised representatives can use this process to report content or products they reasonably believe infringe copyright, trade mark, design or other intellectual-property rights.",
    ],
    sections: [
      {
        heading: "What to include",
        bullets: [
          "Your name, organisation, email and capacity to act for the rights holder.",
          "Identification of the right, including registration details where relevant, and enough information for us to verify it.",
          "The exact product or page URL and a clear explanation of the alleged infringement.",
          "Supporting images, originals, authorisation records or other proportionate evidence.",
          "A good-faith statement that the complained-of use is not authorised by the rights holder, its agent or law, and that the report is accurate.",
        ],
        paragraphs: [
          "Send the report to send@isanroute.space with the subject Intellectual Property Notice. Do not include unnecessary personal data or confidential evidence without first asking how to transfer it securely.",
        ],
      },
      {
        heading: "Our review",
        paragraphs: [
          "We acknowledge a sufficiently detailed report, preserve relevant records and assess the identified use. We may temporarily unpublish a listing, request clarification, consult the supplier or seek legal advice. We do not require a final court order before taking a proportionate precautionary step.",
        ],
      },
      {
        heading: "Response and counter-notice",
        paragraphs: [
          "Where appropriate, the person who supplied the material may be told the substance of the complaint and invited to provide proof of authorisation, independent creation or another lawful basis. We may restore material if the complaint is withdrawn or the evidence supports lawful use.",
        ],
      },
      {
        heading: "False or abusive reports",
        paragraphs: [
          "Do not knowingly make a false claim, impersonate a rights holder or use this process to suppress lawful competition, commentary or comparative information. We may reject abusive notices and preserve them for legal defence.",
        ],
      },
      {
        heading: "Repeat and serious issues",
        paragraphs: [
          "Where a supplier repeatedly provides infringing material, or evidence indicates counterfeit or unsafe goods, we may stop sales, cancel the relationship, notify affected customers and cooperate with competent authorities. Any customer remedy will be handled separately under consumer law.",
        ],
      },
    ],
  },

  security: {
    title: "Security & Fraud Prevention Policy",
    intro: [
      "This policy describes the steps used to protect transactions and how shoppers can report suspicious activity.",
    ],
    sections: [
      {
        heading: "Our approach",
        paragraphs: [
          "We use proportionate access controls, hosted payment processing, software maintenance, logging and transaction checks. No system can be guaranteed completely secure, so controls are reviewed as risks and services change.",
        ],
      },
      {
        heading: "Payment review",
        paragraphs: [
          "Orders may be screened using payment status, address consistency, unusual velocity, device or network signals and sanctions indicators. We may request limited verification or cancel and refund an order if risk cannot reasonably be resolved. Do not send identity documents unless we have explained why they are necessary and how to send them securely.",
        ],
      },
      {
        heading: "Protect yourself",
        bullets: [
          "Check that you are on the expected isanroute website before paying.",
          "Use a unique email password and enable multi-factor authentication with your email and payment provider.",
          "Never email a full card number, card security code or password.",
          "Treat unexpected refund, customs or delivery-payment messages cautiously and verify them through known contact details.",
          "Review statements and contact your issuer promptly about an unrecognised transaction.",
        ],
      },
      {
        heading: "Reporting a vulnerability",
        paragraphs: [
          "Email send@isanroute.space with the affected URL, observed behaviour, date and safe reproduction steps. Do not access personal data, run denial-of-service tests, alter orders or publicly disclose an issue before there has been reasonable time to investigate.",
        ],
      },
      {
        heading: "Suspected data breach",
        paragraphs: [
          "We assess suspected incidents, contain them, document decisions and notify affected people or regulators where legally required. A security report made in good faith will not be ignored merely because it uses informal wording.",
        ],
      },
    ],
  },

  productSafety: {
    title: "Product Safety & Recall Policy",
    intro: [
      "Product safety takes priority over normal return conditions. This policy explains how to report a concern and how recalls are communicated.",
    ],
    sections: [
      {
        heading: "Report a safety concern",
        paragraphs: [
          "Stop using the product if you believe it could cause injury, fire, allergic reaction or another safety risk. Move it to a safe place if this can be done without danger, keep its labels and email send@isanroute.space with the order number, product name, batch or serial information, photographs and a description of what happened.",
        ],
      },
      {
        heading: "Urgent situations",
        paragraphs: [
          "For an immediate threat, contact local emergency services first. Seek appropriate medical advice for an injury or reaction. Customer support is not an emergency or medical service.",
        ],
      },
      {
        heading: "Investigation",
        paragraphs: [
          "We may pause sales, ask the supplier for traceability records, arrange a no-cost return and notify the relevant market-surveillance authority. We will not ask you to continue using a potentially unsafe product merely to reproduce the issue.",
        ],
      },
      {
        heading: "Recall communications",
        paragraphs: [
          "If a recall or corrective action is required, we may use order contact details to send safety information even if you opted out of marketing. A notice will identify the affected product, risk, action to take and available remedy. Safety messages will not be disguised advertising.",
        ],
      },
      {
        heading: "Remedies and disposal",
        paragraphs: [
          "The remedy may include repair, replacement, refund or safe disposal instructions according to the recall and applicable law. Do not destroy or ship a hazardous item until instructions are provided. We cover necessary recall return costs.",
        ],
      },
    ],
  },

  accessibility: {
    title: "Accessibility Statement",
    intro: [
      "isanroute aims to provide a website that can be used by as many people as reasonably possible, including people who use keyboards, screen readers, zoom or other assistive technology.",
    ],
    sections: [
      {
        heading: "Our approach",
        paragraphs: [
          "We work toward clear structure, meaningful labels and image alternatives, visible keyboard focus, readable contrast, responsive layouts and plain-language support information. Accessibility is an ongoing process rather than a one-time claim of perfect conformance.",
        ],
      },
      {
        heading: "Known limitations",
        paragraphs: [
          "Some third-party payment or embedded services are controlled by their providers and may not offer the same experience. Product imagery may not communicate every visual detail through alternative text. We will provide information in another reasonable format where we can.",
        ],
      },
      {
        heading: "Request assistance",
        paragraphs: [
          "If a page, form or checkout step is difficult to use, email send@isanroute.space. Tell us the page, device or assistive technology, the task you were trying to complete and the format you need. Do not include card details.",
        ],
      },
      {
        heading: "Feedback and response",
        paragraphs: [
          "We welcome specific feedback and will prioritise barriers that prevent shopping, accessing policies or contacting support. We aim to acknowledge accessibility reports promptly and provide a practical alternative while a fix is assessed.",
        ],
      },
    ],
  },

  complaints: {
    title: "Complaints & Dispute Resolution Policy",
    intro: [
      "This policy explains how to raise a complaint and how we will try to resolve it fairly. It does not restrict statutory remedies or access to a court or competent authority.",
    ],
    sections: [
      {
        heading: "How to complain",
        paragraphs: [
          "Email send@isanroute.space with the subject Complaint. Include your name, order number, a concise description, relevant dates, the outcome you seek and supporting photographs or documents. Do not send full card details or unnecessary sensitive information.",
        ],
      },
      {
        heading: "What happens next",
        paragraphs: [
          "We will acknowledge the complaint, review order and communication records, and request only information reasonably needed. We aim to provide a substantive response within 14 days. If the matter is complex, we will explain the delay and provide an update.",
        ],
      },
      {
        heading: "Possible outcomes",
        paragraphs: [
          "Depending on the facts and law, an outcome may include an explanation, correction, fulfilment, repair, replacement, price reduction, refund, policy improvement or no further action with reasons. Accepting customer feedback does not require either party to admit legal liability.",
        ],
      },
      {
        heading: "Escalation",
        paragraphs: [
          "If you remain dissatisfied, ask for a second review. Consumers may seek independent information from the Irish Competition and Consumer Protection Commission. Eligible cross-border consumers may contact the European Consumer Centre in their country. Privacy complaints may be made to the Data Protection Commission.",
        ],
      },
      {
        heading: "Fair treatment",
        paragraphs: [
          "We do not penalise a customer for making a good-faith complaint, posting an honest review, asserting a consumer right or requesting accessibility support. Abusive or threatening communication may be limited while another safe contact method remains available.",
        ],
      },
    ],
  },

  sustainability: {
    title: "Packaging & Environmental Claims Policy",
    intro: [
      "This policy sets a standard for accurate environmental information. It is not a claim that every product, shipment or supplier has the same environmental performance.",
    ],
    sections: [
      {
        heading: "Evidence-based claims",
        paragraphs: [
          "We aim to use specific, understandable claims and avoid broad terms such as green, eco-friendly or sustainable unless the context, scope and evidence are clear. A claim about one material or package does not imply that the entire product or business has no environmental impact.",
        ],
      },
      {
        heading: "Product information",
        paragraphs: [
          "Material, origin, recycled content, certification, durability or repair claims apply only where stated on the relevant product page and supported by supplier information or other evidence. Third-party certification marks remain subject to their owners' rules.",
        ],
      },
      {
        heading: "Packaging",
        paragraphs: [
          "We seek to use appropriately sized protective packaging and to avoid unnecessary material where practical. Local recycling rules differ, so check the symbols and guidance provided by your waste authority. Protective packaging should not be removed if doing so would make a return unsafe or cause damage.",
        ],
      },
      {
        heading: "Delivery and returns",
        paragraphs: [
          "Consolidated shipping may reduce packaging but can delay an order containing a pre-order item. We will not discourage a valid return or faulty-goods remedy through unsupported environmental claims.",
        ],
      },
      {
        heading: "Corrections",
        paragraphs: [
          "If an environmental claim appears inaccurate or lacks context, email send@isanroute.space with the page and concern. We will review the evidence and correct or remove a claim where appropriate.",
        ],
      },
    ],
  },
};

export const policyRoutes = [
  { key: "privacy", path: "/privacy", title: "Privacy Policy", summary: "How personal information is collected, used, shared and protected." },
  { key: "cookies", path: "/cookies", title: "Cookie & Storage Policy", summary: "Essential browser storage, third-party services and your controls." },
  { key: "terms", path: "/terms", title: "Terms of Service", summary: "The terms that apply to website use and purchases." },
  { key: "shipping", path: "/shipping", title: "Shipping & Delivery", summary: "Processing, charges, tracking, customs, delay and loss." },
  { key: "returns", path: "/returns", title: "Returns & Refunds", summary: "Our 28-day offer, return conditions and refund timing." },
  { key: "withdrawal", path: "/right-of-withdrawal", title: "Right of Withdrawal", summary: "The statutory cooling-off process and model wording." },
  { key: "payments", path: "/payment-policy", title: "Payment & Billing", summary: "Hosted payment, currency, authorisation and refunds." },
  { key: "orders", path: "/order-policy", title: "Orders & Cancellations", summary: "Order acceptance, changes, cancellation and stock issues." },
  { key: "pricing", path: "/pricing-taxes", title: "Pricing, Taxes & Duties", summary: "USD prices, corrections, conversion and import costs." },
  { key: "promotions", path: "/promotions", title: "Promotions & Discount Codes", summary: "Code use, combinations, fair use and promotional returns." },
  { key: "giftCards", path: "/gift-cards", title: "Gift Cards", summary: "Validity, redemption, balances, refunds and security." },
  { key: "preorders", path: "/pre-orders", title: "Pre-orders & Back-orders", summary: "Estimates, payment, mixed baskets, delays and cancellation." },
  { key: "productInfo", path: "/product-information", title: "Product Information", summary: "Descriptions, sizing, materials, stock and authenticity." },
  { key: "warranty", path: "/faulty-goods", title: "Faulty Goods & Guarantee", summary: "Legal guarantees, assessment, remedies and costs." },
  { key: "consumerRights", path: "/consumer-rights", title: "Consumer Rights", summary: "A plain-language summary of key online shopping rights." },
  { key: "acceptableUse", path: "/acceptable-use", title: "Acceptable Use", summary: "Permitted website use, prohibited conduct and enforcement." },
  { key: "intellectualProperty", path: "/intellectual-property", title: "Intellectual Property", summary: "Ownership, third-party rights and permitted personal use." },
  { key: "takedown", path: "/notice-takedown", title: "Notice & Takedown", summary: "How rights holders can report suspected infringement." },
  { key: "security", path: "/security", title: "Security & Fraud Prevention", summary: "Transaction checks, safety tips and vulnerability reports." },
  { key: "productSafety", path: "/product-safety", title: "Product Safety & Recalls", summary: "Safety reports, investigations, recalls and remedies." },
  { key: "accessibility", path: "/accessibility", title: "Accessibility", summary: "Our approach, known limitations and assistance options." },
  { key: "complaints", path: "/complaints", title: "Complaints & Disputes", summary: "How complaints are reviewed, resolved and escalated." },
  { key: "sustainability", path: "/environmental-claims", title: "Packaging & Environmental Claims", summary: "Evidence standards, packaging and claim corrections." },
];

const byKey = Object.fromEntries(policyRoutes.map((item) => [item.key, item]));

export const policyGroups = [
  {
    title: "Shopping, orders & aftercare",
    items: ["shipping", "returns", "withdrawal", "payments", "orders", "pricing", "promotions", "giftCards", "preorders", "productInfo", "warranty", "consumerRights"].map((key) => byKey[key]),
  },
  {
    title: "Privacy, security & safety",
    items: ["privacy", "cookies", "security", "productSafety"].map((key) => byKey[key]),
  },
  {
    title: "Website & legal",
    items: ["terms", "acceptableUse", "intellectualProperty", "takedown", "accessibility", "complaints", "sustainability"].map((key) => byKey[key]),
  },
];

export default policyData;
